export default __webpack_public_path__ + "static/media/wingding.81132f2f.ttf";